import Vue from 'vue'

let moment = require('moment')
moment.locale('fr')

export const getProchainPassage = (dateProp) => {
  let date = moment(dateProp);
  if (!date.isValid())
    return "Inconnu";
  if (date.month() <= 6)
    return "Mi-" + (date.year() <= moment().year() ? moment().year() : date.year())
  else
    return "Fin " + (date.year() <= moment().year() ? moment().year() : date.year())
  return "Inconnu"
}


Vue.prototype.$getClassNameRecap = function (statut) {
  switch (statut) {
    case 'En cours':
      return 'text-warning'
      break
    case 'En attente de décision':
      return 'text-warning'
      break
    case 'En attente':
      return 'text-warning'
      break
    case 'Annulé / Refusé':
      return 'text-danger'
      break
    case 'Annulée / Refusée':
      return 'text-danger'
      break
    case 'Cloturé / Validé':
      return 'text-green'
      break
    case 'En attente de payement':
      return 'text-aqua'
      break
    default:
      return ''
  }
}

Vue.prototype.$sortCompareAdvanced = function (aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
  const a = aRow[key] // or use Lodash `_.get()`
  const b = bRow[key]
  if (key === 'date_fin' || key === 'date_debut' || key === 'date_naissance') {
    let aDate = moment(aRow[key], 'DD/MM/YYYY')
    let bDate = moment(bRow[key], 'DD/MM/YYYY')
    if (aDate.isValid && bDate.isValid) {
      if (aDate < bDate) {
        return -1
      } else if (aDate > bDate) {
        return 1
      } else {
        return 0
      }
    }
  } else {
    if (
      (typeof a === 'number' && typeof b === 'number') ||
      (a instanceof Date && b instanceof Date)
    ) {
      // If both compared fields are native numbers or both are native dates
      return a < b ? -1 : a > b ? 1 : 0
    } else {
      // Otherwise stringify the field data and use String.prototype.localeCompare
      return this.$toString(a).localeCompare(this.$toString(b), compareLocale, compareOptions)
    }
  }
}

// Helper function to stringify the values of an Object
Vue.prototype.$toString = function (value) {
  if (value === null || typeof value === 'undefined') {
    return ''
  } else if (value instanceof Object) {
    return Object.keys(value)
      .sort()
      .map(key => toString(value[key]))
      .join(' ')
  } else {
    return String(value)
  }
}


// Helper function to stringify the values of an Object
Vue.prototype.$formatDate = function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
  if (value == null) return ''
  return moment(value, fmtIn).format(fmtOut)
}



// WEBPACK FOOTER //
// ./src/utils/utils.js